enum ActionNames {
  ADD_POSTIT = 'ADD_POSTIT',
  LOAD_POSTITS = 'LOAD_POSTITS',
}

export default ActionNames
